import { render, staticRenderFns } from "./KeyIngredientsFocus.vue?vue&type=template&id=3d1bf22d&scoped=true&"
import script from "./KeyIngredientsFocus.vue?vue&type=script&lang=js&"
export * from "./KeyIngredientsFocus.vue?vue&type=script&lang=js&"
import style0 from "./KeyIngredientsFocus.vue?vue&type=style&index=0&id=3d1bf22d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1bf22d",
  null
  
)

export default component.exports